import React from 'react'

export default function GalleryCard({imgUrl, title}) {
    

    return (
        <>
           <div className="group relative bg-white rounded-xl  shadow-lg overflow-hidden transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="relative h-64 overflow-hidden">
                <div className="absolute top-4 right-4 z-10">
                </div>
                <img src={imgUrl} 
                     className="w-full h-full object-cover transform transition duration-500 group-hover:scale-110"
                     alt={title}/>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-4 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  </div>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-1xl font-bold text-orange-600 -mt-0">{title}</h3>
                </div>
                
              </div>
            </div> 
        </>
    )
}
